export function insertIf<T>(condition: boolean, item: T[]): T[] {
  return condition ? [...item] : [];
}
